module.exports = __webpack_public_path__ + "static/media/image_header_01.d73633a5.jpg";